export default (function (value) {
  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isSymbol.js
// module id = 648
// module chunks = 1